import { render, staticRenderFns } from "./shows.vue?vue&type=template&id=1584b9da&scoped=true"
import script from "./shows.vue?vue&type=script&lang=js"
export * from "./shows.vue?vue&type=script&lang=js"
import style0 from "./shows.vue?vue&type=style&index=0&id=1584b9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584b9da",
  null
  
)

export default component.exports